import { gx } from "@/components/gtax/base";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import SumsubWebSdk from "@sumsub/websdk-react";
import { ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gtax`;

export const KycPanel = ({ record }) => {
  const [enabled, setEnabled] = useState(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const creds = { reference: record.reference, email: record.email };

  useEffect(() => {
    axios.get(`${API}/kyc/config`).then(({ data }) => setEnabled(data.enabled)).catch(() => setEnabled(false));
  }, []);

  const newToken = async () => {
    const { data } = await axios.post(`${API}/kyc/session`, creds);
    return data.token;
  };
  const start = () => newToken().then(setToken).catch((e) => setError(e.response?.data?.detail || "Could not start verification."));
  const statusLink = gx(`/status?ref=${record.reference}&email=${encodeURIComponent(record.email)}`);

  return (
    <div className="space-y-8" data-testid="gtax-kyc-panel">
      <div className="pb-8 border-b border-[color:var(--line)]">
        <div className="gx-eyebrow">Agreement signed · your reference</div>
        <div className="gx-serif text-4xl mt-2" data-testid="gtax-kyc-reference">{record.reference}</div>
        <p className="text-sm text-[color:var(--mute)] mt-2">Keep this reference. With your email, it lets you check your status and receive settlement details.</p>
      </div>
      <div className="flex gap-4 items-start">
        <ShieldCheck className="text-[color:var(--gold)] shrink-0 mt-1" size={28} />
        <div>
          <h3 className="gx-caps text-xl">Identity verification</h3>
          <p className="mt-2 text-[color:var(--mute)]">A photo of your passport and a short selfie. It takes about two minutes. The treasury settlement address is released only after your identity is approved.</p>
        </div>
      </div>
      {enabled === false && (
        <div className="gx-card p-6" data-testid="gtax-kyc-manual">
          Online verification is being activated. Our compliance team will contact you at <b>{record.email}</b> to complete your identity check.
        </div>
      )}
      {enabled && !token && !submitted && <button onClick={start} className="gx-btn" data-testid="gtax-kyc-start">Start verification</button>}
      {enabled && token && !submitted && (
        <div data-testid="gtax-kyc-sdk">
          <SumsubWebSdk accessToken={token} expirationHandler={newToken} config={{ lang: "en" }}
            options={{ addViewportTag: false, adaptIframeHeight: true }}
            onMessage={(type) => type === "idCheck.onApplicantSubmitted" && setSubmitted(true)}
            onError={() => setError("Verification window error. Please refresh and try again.")} />
        </div>
      )}
      {submitted && <div className="gx-card p-6" data-testid="gtax-kyc-submitted">Thank you. Your documents are under review.</div>}
      {error && <p className="text-sm text-[#A0523F]" data-testid="gtax-kyc-error">{error}</p>}
      <Link to={statusLink} className="gx-ghost inline-block" data-testid="gtax-kyc-status-link">Check my status</Link>
    </div>
  );
};
